import { ErreurApi } from '../api/client';
import { LIBELLE_ERREUR } from '../i18n/fr';

/** Traduit une erreur en phrase française, sans jamais masquer le code au support. */
export function texteErreur(erreur: unknown): string {
  if (erreur instanceof ErreurApi) {
    return LIBELLE_ERREUR[erreur.code] ?? `Erreur ${erreur.code} (HTTP ${erreur.http}).`;
  }
  if (erreur instanceof Error && erreur.message !== '') return erreur.message;
  return 'Erreur inattendue.';
}

/**
 * Bandeau d'erreur.
 *
 * Le code brut et l'identifiant de corrélation sont TOUJOURS affichés en second plan : c'est un
 * outil interne, et la première question posée au support est « quel code ? ». Les masquer
 * derrière un message générique ferait perdre le seul élément qui permet de retrouver la trace
 * dans les journaux serveur.
 */
export function MessageErreur({
  erreur,
  action,
}: {
  erreur: unknown;
  action?: JSX.Element;
}): JSX.Element | null {
  if (!erreur) return null;

  const code = erreur instanceof ErreurApi ? erreur.code : null;
  const trace = erreur instanceof ErreurApi ? erreur.traceId : undefined;
  const champs = erreur instanceof ErreurApi ? erreur.champs : [];

  return (
    <div className="gv-bandeau gv-bandeau--erreur" role="alert">
      <div className="gv-pile gv-pile--serree" style={{ flex: 1, minWidth: 0 }}>
        <strong>{texteErreur(erreur)}</strong>

        {champs.length > 0 ? (
          <ul style={{ margin: 0, paddingLeft: 18 }}>
            {champs.map((c) => (
              <li key={`${c.champ}-${c.code}`}>
                <span className="gv-mono">{c.champ}</span> — {LIBELLE_ERREUR[c.code] ?? c.code}
              </li>
            ))}
          </ul>
        ) : null}

        {code || trace ? (
          <span className="gv-mono gv-corps-s">
            {code}
            {trace ? ` · trace ${trace}` : ''}
          </span>
        ) : null}
      </div>
      {action}
    </div>
  );
}
